import { Layers } from 'lucide-react';
import { useWorkspaceInfo } from '@/lib/hooks/useWorkspaceInfo';

/**
 * Read-only chip in the top-nav that surfaces the active workspace name so a
 * user always knows which workspace they are operating in (PLT-8889).
 */
export function WorkspaceBadge() {
  const { workspaceName, isLoading } = useWorkspaceInfo();

  if (isLoading) {
    return (
      <div
        data-testid="workspace-badge-skeleton"
        className="bg-muted h-4 w-24 animate-pulse rounded"
      />
    );
  }

  if (!workspaceName) {
    return null;
  }

  return (
    <div
      data-testid="workspace-badge"
      className="text-muted-foreground flex items-center gap-1.5 text-sm font-medium"
      title={workspaceName}
    >
      <Layers className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="max-w-[220px] truncate">{workspaceName}</span>
    </div>
  );
}
